import { isNil } from 'lodash'
import { createSelector } from 'reselect'

import { getDataState } from '../selectors'
import { AUTH_STORE_ID } from './types'

export const getAuthState = createSelector(getDataState, (dataState) => dataState[AUTH_STORE_ID])

export const getCurrentUser = createSelector(getAuthState, ({ currentUser }) => currentUser)

export const getCurrentUserId = createSelector(getAuthState, ({ currentUserId }) => currentUserId)

export const isCorporateLoggedIn = createSelector(getAuthState, (authState) => !!authState.currentUserId)

export const isCorporateDataLoaded = createSelector(getCurrentUser, (currentUser) => !isNil(currentUser))
